(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('MyFiController', MyFiController);

  /* ngInject */
  function MyFiController() {}
})();
